import { Box, Button, Card, CardContent, Checkbox, Dialog, Drawer, FormControl, InputLabel, IconButton, Input, MenuItem, Select, styled, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { delFts, get, getFile, post, postImage } from 'api/apiBridges/httpBridge';
import { useDispatch, useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import Loading from 'components/Load';
import Scrollbars from 'rc-scrollbars';
import { ReportTable } from 'components/reportTable';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { getDataSource } from 'api/ds';
import { colors } from 'styles/colors';
import { useLocalNotifications } from 'components/Events';
import CountProducts from 'components/widgets/countProducts';
import { DateMenu } from 'components/RangeDate';
import usePreventDoubleClick from 'components/AntiDBC';
import { useNavigate } from 'react-router-dom';
import { useDataContextDeal } from 'actions/contextDealClient';
import { MarketClientSelector } from 'store/slices/marketClient';
import _ from 'lodash';
import { NumInput, TextInput, TextInputDesign } from 'components/EIComponents/LittleComponents';
import { Title } from '@mui/icons-material';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { onChangeUploadImage } from 'store/slices/uploadImage';
import useOn from 'components/socketLib/UseOn';
import NoPhoto from '../images/others/noPhoto.png';
import { TabPanel } from 'components/tabPanel';
import { ElementInfo } from 'components/ElementInfo';
import { AddProducts } from 'components/AddProducts';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import ClassicSearch from 'components/classicSearch';
import { ShowModal } from "components/Modal";
import { DealTab, StyledTab } from 'utils/formatters';
import { hoverStyle } from "styles/main";

export function MyConsumables() {
    const [tab, setTab] = useState(undefined);

    const [info, setInfo] = useState(undefined)
    const [search, setSearch] = useState(undefined)
    const [buttons, setButtons] = useState(undefined)
    // @ts-ignore
    const handleChange = (event, newTab) => {
        setTab(newTab);
        sessionStorage.setItem(`CONSUMABELS_cli`, newTab)
    };
    useEffect(() => {
        handleChange(undefined, Number(sessionStorage.getItem(`CONSUMABELS_cli`)) || 0)
    }, []);

    return (

        <Box sx={{ width: '100%', height: '100%'}}>
            <div style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    height: "5%", 
                    margin: "10px 1% 10px 1%"
                }}
            >
                {search || <div></div>}

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '10px',
                    }}>
                        {!info? 
                            <Loading/>
                        :
                            info
                        }
                    </Box>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginLeft: "10px" }}>
                        {buttons}
                    </div>
                </div>
            </div>
            <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                margin: '0% 0% 0% 1%',
                height: "30px",
                minHeight: "30px"
            }}>

                <DealTab label="СПИСОК" />
                <DealTab label="ПОСТАВКИ" />
            </Tabs>

            <TabPanel value={0} select={tab}>
                <MyConsumablesList setInfo={setInfo} setSearch={setSearch} setButtons={setButtons}/>
            </TabPanel>
            <TabPanel value={1} select={tab}>
                <MyConsumablesDelivery setGlobalInfo={setInfo} setSearch={setSearch} setButtons={setButtons}/>
            </TabPanel>

        </Box>
    );
}

const MyConsumablesList = ({setSearch, setInfo, setButtons}) => {

  const { user_id, company_id} = useSelector(
      loginSelector
  );

  const [loading, setLoading] = useState(true);
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [editEl, setEditEl] = useState(undefined);
  const [data, setData] = useState([]);
  const ds = useMemo(() => getDataSource('MyConsumables'), []);


  const [allSKU, setAllSKU] = useState(0)
  const [allProduct, setAllProduct] = useState(0)

  const counttest = () =>{
    console.log("test", data)
    let allsku = 0
    let allproduct = 0
    if (data && data.length > 0){
        allsku = data.length
        for(let i = 0 ; i < data.length ; i++){
            allproduct += data[i].countProduct;
        }
    }
    
    setAllSKU(allsku)
    setAllProduct(allproduct)
  }

  useEffect(() => {
    counttest()
  }, [data]); 


    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);

    const totalConsum = data.reduce((sum, item) => {
        const consumCount = item?.count || 0;
        console.log("consumCount", consumCount)
        console.log("sum", sum)
        //Для правильного подсчета дробных расходников
        return sum += consumCount >= 0? Math.round(consumCount) : Math.floor(consumCount);
    }, 0);

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 10px',}}>
                        Количество SKU: {data.length}
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'}}>
                        Кол-во расходников: {totalConsum} шт.
                    </Typography>
                </>
            )
        }
        setInfo(getInfo())
    }, [totalConsum, data]);

    useEffect(() => {
        const getButtons = () => {
            return (
                <Button 
                    variant="contained" 
                    onClick={() => { setOpenDialogCreate(true) }} 
                    sx={{ borderRadius: "10px", width: '150px', textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap' }}
                >
                    Новый расходник
                </Button>
            )
        }
        setButtons(getButtons())
    }, []);

    useEffect(() => {
        const getSearch = () => {
            return (
                <>
                    <ClassicSearch setChecked={setChecked} setFilter={setFilter} checked={checked}/>
                </>
            )
        }
        setSearch(getSearch())
    }, [checked, setFilter, setChecked]);

  useEffect(() => {
    const fetchData = async () => {

        try {
          setLoading(true);
          let res = await get("consumables/getOnCli", {cid:user_id})
          await Promise.all(res.map(async (el) => {
            if (el.photo) {
                // let img = await getFile("png", {path:el.photo})
                // el.data = {photo: img, title: el.title}
                el.data = {photo: el.photo, title: el.title}
            }
            else {el.data = {photo: undefined, title: el.title}}
            el.data = {
                ...el.data, 
                color:el.color,
                barcode:el.barcode,
                sizeTitle: el.size,
                brand: `user ${el.client_id}`,
                vendorCode: el.id
            }
            let tmp = await get("Deal/checkConsum", {cli: user_id, nmID: `cons${el.id}`})
            el.canEdit = !tmp.used
          }))
          const sortedRes = res.sort((a, b) => b.id - a.id)

          setData(sortedRes)
        } catch (err) {
        } finally {
        setLoading(false);
        }

        
    };   
    
    fetchData();
  }, []); 

    const newConsumable = async ($data) => {
        const visualBlob = $data.blob; 
        
        const res = await post("consumables/create", { ...$data, client_id: user_id });
        
        if (res.message && res.message.id) {
            const newEl = {
                ...res.message,
                count: 0,
                photo: $data.photo,
                data: {
                    title: $data.title,
                    photo: $data.photo,
                    blob: visualBlob
                }
            };
            setData(prev => [newEl, ...prev]);
        }
    };

    const editConsumable = async ($data) => {
        let sendData = { ...$data };
        const visualBlob = $data.blob;

        delete sendData.count;
        delete sendData.data;
        delete sendData.blob;

        await post("consumables/update", { id: editEl.id, ...sendData });
        setData(prevData => {
            return prevData.map((item) => {
                if (item.id === editEl.id) {
                    return {
                        ...item,
                        ...sendData,
                        photo: sendData.photo,
                        data: {
                            ...item.data,
                            title: sendData.title,
                            photo: sendData.photo,
                            blob: visualBlob || item.data.blob 
                        }
                    };
                }
                return item;
            });
        });
    };

  //удаление расходника
  const { showNotification } = useLocalNotifications();
  const del = async (consum) => {
    let tmp = JSON.parse(JSON.stringify(data))
    let idx = tmp.findIndex((fel) => fel.id === consum.id)
    if (idx > -1) {
        if (tmp[idx].count === 0){
            tmp.splice(idx, 1)
            setData(tmp)
            let res = await post("consumables/del", {consum_id: consum.id})}
            else{
                showNotification({
                    id: 'delconsum', 
                    type: 'error', 
                    message: 'На хранении есть товары' 
                });
            }
        }
    }

    const handleClickDelConsum = (consum) => {
        ShowModal('Удалить расходник', 
        <div>Вы уверены, что хотите удалить расходник?</div>, 
        async () => {
            try {
            del(consum)
            }
            catch (err) {}
            finally {}
            
        });
    }

    

    if (loading) {
        return <Loading></Loading>
    }
  
    return (
        <>
          <Dialog
              open={openDialogCreate}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setOpenDialogCreate(false) }}
          >
              <div style={{ height: '700px', width: '700px', padding: '12px' }}>
                  {/* <AddProductToNewDeal data={data} cancel={setOpenDialog} onSave={onAddProduct}></AddProductToNewDeal> */}
                  <CreateConsumable create={(inData) => {newConsumable(inData)}} cancel={setOpenDialogCreate}></CreateConsumable>
              </div>
          </Dialog>
          <Dialog
              open={editEl}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setOpenDialogCreate(false) }}
          >
              <div style={{ height: '700px', width: '350px', padding: '12px' }}>
                  {/* <AddProductToNewDeal data={data} cancel={setOpenDialog} onSave={onAddProduct}></AddProductToNewDeal> */}
                  <EditConsumable edit={(inData) => {editConsumable(inData)}} inputEl={editEl} cancel={(v) => {setEditEl(undefined)}}></EditConsumable>
              </div>
          </Dialog>
          <Box sx={{ width: '100%', height: '100%' }}>    

            <div style={{
                width: '98%', 
                height: "calc(94% - 55px )", 
                overflow: 'hidden',
                margin: "0% 1% 1% 1%",
                borderRadius: "10px",
                borderTopLeftRadius: "0px",
                backgroundColor: 'white'
            }}>
                {loading? <Loading></Loading>: 
                    <Scrollbars
                        // autoHeight
                        // autoHeightMax={"98%"}
                        style={{ width: '100%', height: '100%', borderRadius: "10px" }} 
                    >
                        <ReportTable
                            ds={ds}
                            data={!checked? data: data.filter((el) => {const tf = filter.toLowerCase(); 
                                return (
                                    el.data.title.toLowerCase().includes(tf)
                                )})}
                            autoPagination={10}
                            aditionalAction={
                                        [
                                            {
                                                action: (item) => {setEditEl(item)},
                                                ui: () => {return (
                                                    <EditIcon
                                                        sx={{
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': hoverStyle
                                                        }}
                                                    />
                                                )},
                                                flag: "canEdit"
                                            },
                                            {
                                                action: (item) => {handleClickDelConsum(item)},
                                                ui: () => {return (
                                                    <DeleteForeverIcon
                                                        sx={{
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': hoverStyle
                                                        }}
                                                    />
                                                )}
                                            }
                                        ]
                                    }
                            />
                    </Scrollbars>
                }
            </div>
          </Box>
        </>
      );
};

function CreateConsumable({create, cancel}) {
    const [isLoading, setIsLoading] = useState(false);
    
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const [data, setData] = useState({
        photo: "",
        blob: "",
        count:'0',
        title: '',
        color: '',
        size: '',
        dimensions: {
            length: '',
            height: '',
            width: ''
        },
        consum: "",
        rck: {title: "ед", kof: 1}
    })

    const dispatch = useDispatch();
    const { socket } = useContext(SocketContext);
    const onSubmit = useCallback((data) => {
        dispatch(onChangeUploadImage(data));
    }, [dispatch]);
    const { user_id} = useSelector(
        loginSelector
    );

    useOn('uploadDealImage', async ($data) => {
        console.log("uploadDealImage", $data);
        let photo = await getFile("png", {path:$data.path});
        
        if (photo) {

            let tmp = JSON.parse(JSON.stringify(data))
            tmp.photo = $data.path
            tmp.blob = photo
            setData(tmp)
            
            showNotification({
                id: 'test', 
                type: 'success', 
                message: 'Изображение загруженно' 
            });
        }
    });

    const handleFileUpload = useCallback(async (event, dataPath) => {
        let selectedFiles = Array.from(event.target.files);
        if (selectedFiles && selectedFiles.length > 0) {
            let rightFiles = []
            selectedFiles.map((file) => {
            if (file.type === "image/png" || file.type === "image/jpeg") {
                rightFiles.push(file)
            }
            else {
                showNotification({
                id: 'uploadDealImageErr', // Уникальный идентификатор
                type: 'error', // Тип уведомления
                message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
                });
            }
            })
            if (rightFiles.length > 0 ) {
                onSubmit({ upload: true });
                showNotification({
                    id: 'uploadImage', // Уникальный идентификатор
                    type: 'info', // Тип уведомления
                    message: 'Загрузка' // Текст сообщения
                });

                postImage(rightFiles, socket.id, {user_id, role:`Consumable`, content_type:"uploadDealImage", dataPath}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
                setIsLoading(true);
            }
        }
        else {
            setIsLoading(false);
        }
    }, [onSubmit]);

    const handleFileDel = async (dataPath) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let old = _.get(tmp, dataPath)
        _.set(tmp, dataPath, "")
        _.set(tmp, 'blob', undefined)
        if (old) {
            await delFts('/delete-file', {path:[old], taskType: "delImage"}, socket.id)
        }
        setData(tmp)
    }

    const goBind = () => {
        const isValid = data.title && data.title.trim() !== "" && data.consum !== "";

        if (isValid) {
            create(data);
            cancel(false);
        } else {
            showNotification({
                id: 'valueError', 
                type: 'error', 
                message: 'Заполните поля "Название" и "Тип расходника"' 
            });
        }
    }

    const editNumValue = (path, val) => {
        let num = parseInt(val)
        if (!isNaN(num)) {
            let tmp = JSON.parse(JSON.stringify(data))
            _.set(tmp, path, num)
            setData(tmp)
        }
    }
    const editTextValue = (path, val) => {
        let tmp = JSON.parse(JSON.stringify(data))
        _.set(tmp, path, val)
        setData(tmp)
    }

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
                overflow: "hidden"
            }}
        >
            {/* Заголовок */}

            <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "text.primary",

                }}
            >
                Новый расходник
            </Typography>


            <div style={{display:"flex", flexDirection: 'column', height: "100%"}}>
                <div style={{width: "100%", display: 'flex', flexDirection: 'row', gap: '10px'}}>
                    {data.blob? (
                        <div style={{ width: '70px', height: '100px', flexShrink: 0, marginBottom: '10px', position: 'relative' }}>
                                <img
                                    alt=""
                                    src={data.blob}
                                    style={{
                                        border: '1px solid gray',
                                        borderRadius: '10px',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                                {/* Кнопка удаления */}
                                <IconButton
                                    size="small"
                                    onClick={() => handleFileDel('photo')}
                                    sx={{
                                        position: 'absolute', top: -8, right: -8,
                                        backgroundColor: 'white', boxShadow: 2, width: '24px', height: '24px',
                                        "&:hover": { backgroundColor: "#f0f0f0" }, zIndex: 10
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: '16px', color: "red" }} />
                                </IconButton>
                                
                                {/* Скрытый инпут для смены фото кликом */}
                                <label htmlFor="change-image-edit" style={{ position: 'absolute', inset: 0, cursor: 'pointer', zIndex: 1 }} />
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    id="change-image-edit"
                                    onChange={(event) => { handleFileUpload(event, 'photo') }}
                                />
                            </div>
                        
                        ) : isLoading ? (
                        <div style={{ 
                            width: '70px', 
                            height: '105px', 
                            marginRight: '10px', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            border: '1px solid lightgray', 
                            borderRadius:'10px' 
                            }}>
                                <div style={{ transform: 'scale(0.7)' }}><Loading></Loading></div>
                            </div>
                        )
                        :
                        <div style={{ width: '70px', height: '105px', marginRight: '10px' }}>
                            <input
                                type="file"
                                multiple
                                accept="application/png"
                                style={{ display: "none" }}
                                id="upload-image"
                                onChange={(event) => {handleFileUpload(event, 'photo')}}
                            />
                            <label 
                                htmlFor="upload-image" 
                                style={{ 
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%', 
                                    height: '100%',
                                    border: '1px solid gray', 
                                    borderRadius:'10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <img 
                                    alt="" 
                                    src={NoPhoto} 
                                    style={{ 
                                        maxWidth: '70px', 
                                        maxHeight: '70px', 
                                        width: '100%', 
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                ></img>
                            </label>
                        </div>
                    }
                    <div style={{width: "calc( 100% - 70px)", display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        <TextInputDesign title={"Название"} val={data?.title} onChange={(e) => editTextValue("title", e)}></TextInputDesign>
                        <TextInputDesign title={"Цвет"} val={data?.color} onChange={(e) => editTextValue("color", e)}></TextInputDesign>
                        <TextInputDesign title={"Размер"} val={data?.size} onChange={(e) => editTextValue("size", e)}></TextInputDesign>
                    </div>
                </div>
                <div style={{width: "100%", display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'flex-end'}}>
                    <div style={{width: "calc( 100% - 88px)", display: 'flex', flexDirection: 'column', gap: '10px'}}   >
                        <TextInputDesign title={"Длина"} val={data?.dimensions.length} onChange={(e) => editNumValue("dimensions.length", e)}></TextInputDesign>
                        <TextInputDesign title={"Ширина"} val={data?.dimensions.width} onChange={(e) => editNumValue("dimensions.width", e)}></TextInputDesign>
                        <TextInputDesign title={"Высота"} val={data?.dimensions.height} onChange={(e) => editNumValue("dimensions.height", e)}></TextInputDesign>
                        <FormControl sx={{width: "100%"}}>
                            <Typography 
                                component="label" 
                                sx={{display: 'block', textAlign: 'left', color: '#666666', marginTop: '5px'}}
                                fontSize='16px'
                                
                            >Единица измерения</Typography>

                            <Select
                                value={data?.rck.title}
                                onChange={(e) => {editTextValue("rck.title", e.target.value)}}
                                displayEmpty 
                                inputProps={{ 'aria-label': 'Without label' }}
                                style={{
                                    borderRadius: "15px",
                                    fontSize: "15px",
                                    marginRight: "2px",
                                    height: "40px"
                                }}
                            >
                                <MenuItem value={"ед"}> 
                                    <Typography variant="body1">ед</Typography>
                                </MenuItem>
                                <MenuItem value={"см"}> 
                                    <Typography variant="body1">см</Typography>
                                </MenuItem>
                                <MenuItem value={"гр"}> 
                                    <Typography variant="body1">гр</Typography>
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <NumInput title={`Количество ${data?.rck.title} в 1 шт товара`} val={data?.rck.kof} onChange={(e) => {editNumValue("rck.kof", e)}}/>
                        <FormControl sx={{width: "100%"}}>
                            <Typography 
                                component="label" 
                                sx={{display: 'block', textAlign: 'left', color: '#666666', marginTop: '5px'}}
                                fontSize='16px'
                                
                            >Тип расходника</Typography>

                            <Select
                                value={data?.consum}
                                onChange={(e) => {editTextValue("consum", e.target.value)}}
                                displayEmpty 
                                inputProps={{ 'aria-label': 'Without label' }}
                                style={{
                                    borderRadius: "15px",
                                    fontSize: "15px",
                                    marginRight: "2px",
                                    height: "40px"
                                }}
                            >
                                <MenuItem value={"other"}> 
                                    <Typography variant="body1">Для комплектации</Typography>
                                </MenuItem>
                                <MenuItem value={"additional"}> 
                                    <Typography variant="body1">Дополнительный</Typography>
                                </MenuItem>
                                <MenuItem value={"pack"}> 
                                    <Typography variant="body1">Упаковка</Typography>
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
            

            {/* Нижняя панель с кнопками и полем ввода */}
            <Box

                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >

                <Button
                    onClick={() => {cancel(false); handleFileDel('photo')}}
                    variant="contained"
                    size="medium"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 3,
                        backgroundColor: "grey.500",
                        "&:hover": { backgroundColor: "grey.600" },
                    }}
                >
                    Отмена
                </Button>
                <Button
                    onClick={preventDoubleClick(goBind, 1000)}
                    variant="contained"
                    size="medium"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 3,
                    }}
                >
                    Добавить
                </Button>
            </Box>
        </Box>
    );
}

function EditConsumable({edit, inputEl, cancel}) {
    const [isLoading, setIsLoading] = useState(false);
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();

    const [data, setData] = useState({
        photo: "",
        blob: "",
        count: '0',
        title: '',
        color: '',
        size: '',
        dimensions: { length: '', height: '', width:'' },
        consum: "other",
        rck: {title: "ед", kof: 1}
    });

    const dispatch = useDispatch();
    const { socket } = useContext(SocketContext);
    const { user_id } = useSelector(loginSelector);

    useEffect(() => {
        const loadPhoto = async () => {
            if (inputEl) {
                let initData = { ...inputEl };
                const photoPath = inputEl.data?.photo || inputEl.photo;
                if (photoPath && !initData.blob) {
                    try {
                        const fetchedImage = await getFile("png", { path: photoPath });
                        initData.blob = fetchedImage; 
                        initData.photo = photoPath;
                    } catch (e) {
                        console.error("Не удалось загрузить фото", e);
                    }
                }
                setData(initData);
            }
        };
        loadPhoto();
    }, [inputEl]);

    const onSubmit = useCallback((data) => {
        dispatch(onChangeUploadImage(data));
    }, [dispatch]);

    useOn('uploadDealImage', async ($data) => {
        let photo = await getFile("png", { path: $data.path });
        if (photo) {
            let tmp = JSON.parse(JSON.stringify(data));
            tmp.photo = $data.path;
            tmp.blob = photo;
            setData(tmp);
            showNotification({ id: 'test', type: 'success', message: 'Изображение загружено' });
        }
    });

    const handleFileUpload = useCallback(async (event, dataPath) => {
        let selectedFiles = Array.from(event.target.files);
        if (selectedFiles && selectedFiles.length > 0) {
            let rightFiles = []
            selectedFiles.map((file) => {
            if (file.type === "image/png" || file.type === "image/jpeg") {
                rightFiles.push(file)
            }
            else {
                showNotification({
                id: 'uploadDealImageErr', // Уникальный идентификатор
                type: 'error', // Тип уведомления
                message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
                });
            }
            })
            if (rightFiles.length > 0 ) {
                onSubmit({ upload: true });
                showNotification({
                    id: 'uploadImage', // Уникальный идентификатор
                    type: 'info', // Тип уведомления
                    message: 'Загрузка' // Текст сообщения
                });

                await postImage(rightFiles, socket.id, {
                    user_id,
                    role: `Consumable`,
                    content_type: "uploadDealImage",
                    dataPath
                });
                
                onSubmit({ upload: false });
                setIsLoading(true);
            }
        }
        else {
            setIsLoading(false);
        }
    }, [onSubmit, socket.id, user_id]);

    const handleFileDel = async (dataPath) => {
        let tmp = JSON.parse(JSON.stringify(data));
        let old = _.get(tmp, dataPath);

        _.set(tmp, dataPath, "");
        _.set(tmp, 'blob', undefined);
        if (old) {
            try {
                await delFts('/delete-file', { path: [old], taskType: "delImage" }, socket.id);
            } catch (e) { console.log("Ошибка удаления файла"); }
        }
        setData(tmp);
    };

    const goBind = () => {
        if (data.title && data.consum) {
            edit(data);
            cancel(false);
        } else {
            showNotification({ id: 'valueError', type: 'error', message: 'Заполните Название и Тип' });
        }
    };

    const editNumValue = (path, val) => {
        let tmp = JSON.parse(JSON.stringify(data));
        if (val === "") {
            _.set(tmp, path, "");
            setData(tmp);
        } else {
            let num = parseInt(val);
            if (!isNaN(num)) {
                _.set(tmp, path, num);
                setData(tmp);
            }
        }
    };

    const editTextValue = (path, val) => {
        let tmp = JSON.parse(JSON.stringify(data));
        _.set(tmp, path, val);
        setData(tmp);
    };

    return (
        <Box sx={{ height: '100%', display: "flex", flexDirection: "column", p: 1, gap: 2, overflow: "hidden" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold", color: "text.primary" }}>
                Редактирование расходника
            </Typography>
            <div style={{ display: "flex", flexDirection: 'column', flex: 1, overflowY: 'auto', paddingRight: '5px' }}>
                
                {/* Блок с фото */}
                <div style={{ width: '70px', height: '105px', flexShrink: 0, marginBottom: '10px', position: 'relative' }}>
                    {data.blob ? (
                        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                            <img
                                alt=""
                                src={data.blob}
                                style={{
                                    border: '1px solid gray',
                                    borderRadius: '10px',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                            {/* Кнопка удаления */}
                            <IconButton
                                size="small"
                                onClick={() => handleFileDel('photo')}
                                sx={{
                                    position: 'absolute', top: -8, right: -8,
                                    backgroundColor: 'white', boxShadow: 2, width: '24px', height: '24px',
                                    "&:hover": { backgroundColor: "#f0f0f0" }, zIndex: 10
                                }}
                            >
                                <CloseIcon sx={{ fontSize: '16px', color: "red" }} />
                            </IconButton>
                            
                            {/* Скрытый инпут для смены фото кликом */}
                            <label htmlFor="change-image-edit" style={{ position: 'absolute', inset: 0, cursor: 'pointer', zIndex: 1 }} />
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id="change-image-edit"
                                onChange={(event) => { handleFileUpload(event, 'photo') }}
                            />
                        </div>
                    ) : isLoading ? (
                        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid lightgray', borderRadius: '10px' }}>
                            <div style={{ transform: 'scale(0.7)' }}><Loading /></div>
                        </div>
                    ) : (
                        <div style={{ width: '100%', height: '100%' }}>
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id="upload-image-edit"
                                onChange={(event) => { handleFileUpload(event, 'photo') }}
                            />
                            <label htmlFor="upload-image-edit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', border: '1px solid gray', borderRadius: '10px', cursor: 'pointer' }}>
                                <img alt="" src={NoPhoto} style={{ maxWidth: '70px', maxHeight: '70px', width: '100%', height: '100%', objectFit: 'contain' }} />
                            </label>
                        </div>
                    )}
                </div>

                <TextInput title={"Название"} val={data?.title} onChange={(e) => editTextValue("title", e)} />
                <TextInput title={"Цвет"} val={data?.color} onChange={(e) => editTextValue("color", e)} />
                <TextInput title={"Размер"} val={data?.size} onChange={(e) => editTextValue("size", e)} />
                <TextInput title={"Длина"} val={data?.dimensions.length} onChange={(e) => editNumValue("dimensions.length", e)} />
                <TextInput title={"Ширина"} val={data?.dimensions.width} onChange={(e) => editNumValue("dimensions.width", e)} />
                <TextInput title={"Высота"} val={data?.dimensions.height} onChange={(e) => editNumValue("dimensions.height", e)} />
                <FormControl sx={{width: "100%"}}>
                    <Typography 
                        component="label" 
                        sx={{display: 'block', textAlign: 'left', color: '#666666', marginTop: '5px'}}
                        fontSize='16px'
                        
                    >Единица измерения</Typography>

                    <Select
                        value={data?.rck.title}
                        onChange={(e) => {editTextValue("rck.title", e.target.value)}}
                        displayEmpty 
                        inputProps={{ 'aria-label': 'Without label' }}
                        style={{
                            borderRadius: "15px",
                            fontSize: "15px",
                            marginRight: "2px",
                            height: "40px"
                        }}
                    >
                        <MenuItem value={"ед"}> 
                            <Typography variant="body1">ед</Typography>
                        </MenuItem>
                        <MenuItem value={"см"}> 
                            <Typography variant="body1">см</Typography>
                        </MenuItem>
                        <MenuItem value={"гр"}> 
                            <Typography variant="body1">гр</Typography>
                        </MenuItem>
                    </Select>
                </FormControl>
                <NumInput title={`Количество ${data?.rck.title} в 1 шт товара`} val={data?.rck.kof} onChange={(e) => {editNumValue("rck.kof", e)}}/>
                <FormControl sx={{ width: "100%", marginTop: 2 }}>
                    <Typography component="label" sx={{ display: 'block', textAlign: 'left', color: '#666666', marginBottom: '5px' }} fontSize='16px'>
                        Тип расходника
                    </Typography>
                    <Select
                        value={data?.consum || "other"}
                        onChange={(e) => { editTextValue("consum", e.target.value) }}
                        displayEmpty
                        sx={{ borderRadius: "15px", height: "40px" }}
                    >
                        <MenuItem value={"other"}> 
                            <Typography variant="body1">Для комплектации</Typography>
                        </MenuItem>
                        <MenuItem value={"additional"}> 
                            <Typography variant="body1">Дополнительный</Typography>
                        </MenuItem>
                        <MenuItem value={"pack"}> 
                            <Typography variant="body1">Упаковка</Typography>
                        </MenuItem>
                    </Select>
                </FormControl>
            </div>

            <Box sx={{ mt: 'auto', display: "flex", justifyContent: "flex-end", gap: 2, flexShrink: 0 }}>
                <Button onClick={preventDoubleClick(goBind, 1000)} variant="contained" sx={{ textTransform: "none", fontWeight: "bold", px: 3 }}>
                    Сохранить
                </Button>
                <Button onClick={() => cancel(false)} variant="contained" sx={{ textTransform: "none", fontWeight: "bold", px: 3, backgroundColor: "grey.500", "&:hover": { backgroundColor: "grey.600" } }}>
                    Отмена
                </Button>
            </Box>
        </Box>
    );
}


function MyConsumablesDelivery({setSearch, setGlobalInfo, setButtons}) {
    // для открытия окна с товарами
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    /** @type {[any, Function]} */
    const [data, setData] = useState([]);
    // для шторки
    const [info, setInfo] = useState({ open: false, info: null });
    // загружаем дескриптор  и немного его изменяем чтобы показывать детали сделки
    const ds = useMemo(() => {
        const $ds = getDataSource('createDeliveryConsumes'); 
        $ds.descr.showDetails = (obj) => {
            console.log(obj);
            setInfo({ open: true, info: obj.id });
        };
        return $ds;
    }, []);

    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            id: {name: "Номер", active: true},
            warehouse_market: {name: "Склад назначения", active: true},
            products: {name: "Товары", active: true},
        }
    );

    const { user_id } = useSelector(
        loginSelector
    );

    const allConsum = data.reduce((sum, item) => {
        const consumCount = item.includes_products?.counts.all || 0;
        return sum + consumCount;
    }, 0);
    const factConsum = data.reduce((sum, item) => {
        const consumCount = item.data?.units || 0;
        return sum + consumCount;
    }, 0);

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 10px' }}>
                        Кол-во сделок: {data.length}
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        Кол-во отгруженного товара: {allConsum} шт.
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        Кол-во фактического товара: {factConsum} шт.
                    </Typography>
                </>
            )
        }
        setGlobalInfo(getInfo())
    }, [allConsum, factConsum, data]);

    useEffect(() => {
        const getButtons = () => {
            return (
                <Button 
                    variant="contained" 
                    onClick={() => { setOpen(true) }} 
                    sx={{ borderRadius: "10px", width: '150px', textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap' }}
                >
                    Создать поставку
                </Button>
            )
        }
        setButtons(getButtons())
    }, []);

    useEffect(() => {
        const getSearch = () => {
            return (
                <>
                    <ClassicSearch 
                        setChecked={setChecked} 
                        setFilter={setFilter} 
                        checked={checked}
                        // @ts-ignore
                        fields={filterFields}
                        // @ts-ignore
                        setFields={setFilterFields}
                    />
                </>
            )
        }
        setSearch(getSearch())
    }, [checked, setFilter, setChecked, filterFields, setFilterFields]);

    // получение сделок
    const getData = async () => {
        if (ds?.get) {
            setLoading(true)
            // const res = await ds.get(user_id, 'consum');
            const res = await get('Deal/getClientDealsConsumes', {cid:user_id})
            setData(res)
            setLoading(false)
        } else {
            return [];
        }
    }


    useEffect(() => {
        getData()
    }, []); 

    

    // пока данные получаем отображаем загрузку
    if (loading) {
        return <Loading></Loading>
        
    }

    console.log("DATA", data)

    return (
        <Box sx={{ width: '100%', height: '100%'}}>
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    <AddProducts 
                        cancel={setOpen} 
                        // @ts-ignore
                        defMarket={"consum"}
                    />
                </div>
            </Dialog>
            <div style={{
                width: '98%', 
                height: "calc(94% - 55px )", 
                overflow: 'hidden',
                margin: "0% 1% 1% 1%",
                borderRadius: "10px"
            }}>
                {loading? <Loading></Loading>: 
                    <Scrollbars
                        // autoHeight
                        // autoHeightMax={"98%"}
                        style={{ width: '100%', height: '100%', borderRadius: "10px" }} 
                        renderView={({ style, ...props }) => (
                            <div 
                            {...props} 
                            style={{ 
                                ...style, 
                                paddingRight: '10px',   // отступ справа под вертикальный скролл
                                paddingBottom: '10px',   // отступ снизу под горизонтальный скролл
                                backgroundColor: "#ffffff",
                            }} 
                            />
                        )}
                        // Настройка горизонтального ползунка
                        renderThumbHorizontal={({ style, ...props }) => (
                            <div
                                {...props}
                                style={{
                                    ...style,
                                    backgroundColor: "#808080",
                                    height: "10px",
                                    borderRadius: "5px",
                                    cursor: "pointer"
                                }}
                            />
                        )}
                        renderThumbVertical={({ style, ...props }) => (
                            <div
                                {...props}
                                style={{
                                    ...style,
                                    backgroundColor: "#808080",
                                    width: "10px",
                                    borderRadius: "5px",
                                    cursor: "pointer"
                                }}
                            />
                        )}
                    >
                        <ReportTable 
                            ds={ds} 
                            data={!checked? data: data.filter((el) => {
                                const tf = filter.toLowerCase(); 
                                return (
                                    filterFields.id.active &&
                                        el.data.cdn &&
                                        String(el.data.cdn).includes(tf) || 
                                    filterFields.warehouse_market.active &&
                                        el.warehouse_market && 
                                        String(el.warehouse_market).toLowerCase().includes(tf) || 
                                    filterFields.products.active &&
                                        el.includes_products.products &&
                                        el.includes_products.products.map(p => p.title).join("").toLowerCase().includes(tf) 
                                )
                                })}          
                            >
                        </ReportTable>
                    </Scrollbars>
                }
            </div>  

            <Drawer
                anchor='right'
                open={info.open}
                onClose={() => { setInfo({ open: false, info: null }) }}
            >
                <ElementInfo 
                    ds={getDataSource('EICreateDelivery')} 
                    // @ts-ignore
                    data={info.info} 
                />
            </Drawer>

        </Box>

    );
}


export default MyConsumables;
